import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMembers, IMemberSubscriptions, IState } from 'types/Members';
import { isSubscriptionValid } from 'utils/utils';
import { searchMemberThunk } from './membersThunk';

const initialState: IState = {
	errorCode: 0,
	errorMessage: '',
	members: null,
};

export const searchMembers = createAsyncThunk(
	'members/searchMembers',
	searchMemberThunk,
);

const membersSlice = createSlice({
	name: 'members',
	initialState,
	reducers: {
		resetMembers: () => initialState,
	},
	extraReducers: builder => {
		builder
			.addCase(searchMembers.fulfilled, (state, { payload }) => {
				state.errorCode = 0;
				state.errorMessage = '';

				const { memberId, dateOfService } = payload.inputProps;

				//if there is only a member with an error lets show the error instead
				if (payload.members.length === 1 && payload.members[0].errors?.length > 0) {
					state.errorCode = payload.members[0].errors[0];
					state.errorMessage = '';
					state.members = null;
					return;
				}

				const members = payload.members
					.map((member: IMembers) => {
						const {
							firstName,
							lastName,
							fullName,
							fiscalCodeMasked,
							subscriptions,
							birthDate,
							errors,
						} = member;

						const subs = subscriptions.filter(sub =>
							isSubscriptionValid(sub, memberId, dateOfService),
						);

						return {
							firstName,
							lastName,
							fullName,
							fiscalCodeMasked,
							subscriptions: subs.length
								? subs
								: errors?.length
								? [
										{
											client: '',
											externalMemberId: '',
											networkName: '',
											relationship: '',
											subscriberMemberId: '',
											validTo: '',
											validFrom: '',
											subscriptionUuid: '',
										},
								  ]
								: [],
							birthDate,
							fiscalCode: payload.inputProps.fiscalCode,
							errors,
						};
					})
					.filter(
						(member: IMembers & { subscriptions: IMemberSubscriptions[] }) =>
							member.subscriptions.length > 0,
					);

				state.members = members;
			})
			.addCase(searchMembers.rejected, (state: IState, { payload }: any) => {
				state.errorCode = payload.data.errorCode;
				state.errorMessage = payload.data.message;
				state.members = null;
			});
	},
});

export const { resetMembers } = membersSlice.actions;
export default membersSlice.reducer;
